import React from 'react';
import Styles from './summarycard.module.scss';
import SummaryTable from './SummaryTable';
import DueTodayContainer from './DueTodayContainer';

const SummaryCard = () => (
  <div className={Styles.summarycard}>
    <SummaryTable tooltipcontent="The exact amount you pay will vary month-to-month based on your sending volume and contact list size." title="Summary" />
    <DueTodayContainer tooltipcontent="Your plan and add-on cost is prorated from today to the first of the next month." title="What you'll pay today" />
  </div>

);

SummaryCard.propTypes = {

};

export default SummaryCard;



// WEBPACK FOOTER //
// ./src/components/SummaryCard.jsx